module.exports = __webpack_public_path__ + "img/叶坪中华苏维埃共和国总金库旧址.6ab11a4c.png";